import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, Col, Row, CardTitle } from "reactstrap";
import ChartistGraph from "react-chartist";
import { Link } from "react-router-dom";
import RadialChart from "./RadialChart";

const Piechart = ({ series, symbol }) => {
  return (
    <React.Fragment>
      <Card className="mb-2">
        <CardBody className="border">
          <Row>
            <Col lg="12">
              <h4 className="card-title mb-3 d-flex justify-content-center">
                {symbol} Token
              </h4>
              <Row className="justify-content-center">
                <Col sm={12} className="">
                  <Row className="mt-2">
                    <Col
                      xs="12"
                      className="mb-0 d-flex justify-content-center "
                    >
                      <div>
                        <div className=" d-flex">
                          <p className="text-muted mb-2">
                            <span
                              // className="bg-primary"
                              style={{
                                padding: "0px 12px 0px 7px",
                                borderRadius: "12px",
                                marginRight: "5px",
                                backgroundColor: "#143",
                              }}
                            ></span>{" "}
                            Total Supply{" "}
                          </p>
                          <h5 className="mb-0 ps-2">{series}</h5>
                        </div>

                        {/* <div className="me-3 mt-3 d-flex">
                          <p className="text-muted mb-2">
                            {" "}
                            <span
                              className="bg-success"
                              style={{
                                padding: "0px 12px 0px 7px",
                                borderRadius: "12px",
                                marginRight: "5px",
                              }}
                            ></span>{" "}
                            The Little Things{" "}
                          </p>
                          <h5 className="mb-0 ps-2">10</h5>
                        </div> */}
                      </div>
                    </Col>
                  </Row>
                  <RadialChart
                    dataColors='["#143","--bs-success"]'
                    supply={series}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Piechart;
